import { type ContinuousRangeValue, makeContinuousRangeValue } from './range';
import { BigDecimal } from 'effect';

export const clampRange = (
  min: BigDecimal.BigDecimal,
  max: BigDecimal.BigDecimal,
  serverMin: BigDecimal.BigDecimal,
  serverMax: BigDecimal.BigDecimal
): ContinuousRangeValue => {
  const clampedMin = BigDecimal.clamp(min, { minimum: serverMin, maximum: serverMax });
  const clampedMax = BigDecimal.clamp(max, { minimum: serverMin, maximum: serverMax });

  if (BigDecimal.isGreaterThan(clampedMin, clampedMax)) {
    return makeContinuousRangeValue({ min: serverMin, max: serverMax });
  }

  return makeContinuousRangeValue({ min: clampedMin, max: clampedMax });
};
